<TextInputStyleProvider><BaseInput v-bind="$attrs" :label="label" :type="InputElementTypes.Text"></BaseInput></TextInputStyleProvider>